import React from 'react'

type Props = {
    className?  : any

    option?     : any

    onClick?    : func
}

export default function FieldRAG_Icon(props:Props) {

    const onClick = () => {
        if (props.onClick) props.onClick(props.option)
    }

    const value = props.option ? typeof props.option.value === 'string' ? parseInt(props.option.value) : props.option.value : null

    const classes = Classes("ui5-ico-rag flex-row-center-center", props.className, {
        'red'   : value === 0,
        'amber' : value === 1,
        'green' : value === 2,
    })

    return <div className={classes} onClick={onClick}/>
}